import React from 'react'
import { Link } from 'react-router-dom'
import { COMPANY } from '../data/siteData'

export default function CtaBanner({
  title = 'Klar til at få din opgave vurderet?',
  description = 'Kontakt JT Knudsen ved Jonas Knudsen, når du vil have en personlig dialog om nedgravning af trampolin, fundament, belægning eller andet bygge- og anlægsarbejde.',
  primaryBtnText = 'Få et uforpligtende tilbud',
  primaryBtnLink = '/kontakt'
}) {
  return (
    <section className="relative overflow-hidden bg-stone-900 text-white py-14 sm:py-16 border-y border-stone-800">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#015205_1px,transparent_1px)] [background-size:16px_16px] pointer-events-none"></div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#015205]/40 text-emerald-400 border border-[#015205]/60 text-xs font-bold uppercase tracking-wider mb-3">
          <i className="fa-solid fa-handshake" aria-hidden="true"></i>
          <span>Direkte kontakt til fagmand</span>
        </span>

        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-white max-w-2xl mx-auto">
          {title}
        </h2>

        <p className="mt-3 text-base sm:text-lg text-stone-300 max-w-2xl mx-auto leading-relaxed">
          {description}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to={primaryBtnLink}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-7 py-3.5 rounded-lg bg-[#015205] hover:bg-[#026b07] active:bg-[#014204] text-white font-bold text-base shadow-lg shadow-[#015205]/30 transition-all cursor-pointer whitespace-nowrap"
          >
            <span>{primaryBtnText}</span>
            <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
          </Link>

          <a
            href={COMPANY.phoneHref}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-6 py-3.5 rounded-lg bg-stone-800 hover:bg-stone-700 text-stone-100 font-bold text-base border border-stone-700 transition-colors whitespace-nowrap"
          >
            <i className="fa-solid fa-phone text-emerald-400" aria-hidden="true"></i>
            <span>Ring på {COMPANY.phone}</span>
          </a>
        </div>

        <div className="mt-8 pt-6 border-t border-stone-800/80 flex flex-wrap items-center justify-center gap-6 text-xs text-stone-400">
          <div className="flex items-center gap-2">
            <i className="fa-solid fa-circle-check text-emerald-400 text-xs" aria-hidden="true"></i>
            <span>Uforpligtende prisoverslag</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="fa-solid fa-circle-check text-emerald-400 text-xs" aria-hidden="true"></i>
            <span>Du taler direkte med Jonas</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="fa-solid fa-circle-check text-emerald-400 text-xs" aria-hidden="true"></i>
            <span>Hjortshøj, Østjylland & Djursland</span>
          </div>
        </div>
      </div>
    </section>
  )
}
